function FullLayout(props) {
  return (
    <div
      className="page page-center"
      style={{
        width: "100%",
        minHeight: "100vh",
      }}>
      {props.children}
    </div>
  );
}

export default FullLayout;
